module.exports = __webpack_public_path__ + "img/transfer.ef67f206.png";